"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const AddDescriptionForm = (props) => {
    const { description, setDescription } = props;
    return (react_1.default.createElement("div", { className: 'add-description-item' },
        react_1.default.createElement("div", null, "Add Note (Optional)"),
        react_1.default.createElement("textarea", { value: description, onChange: (e) => setDescription(e.target.value) }),
        react_1.default.createElement("i", null, "Please add which share this is for and any other information")));
};
exports.default = AddDescriptionForm;
